export default __webpack_public_path__ + "static/board-4351099c7e8709894fcc7d22c9d97b58.png";